import React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Constants } from '../Content';
import { ViewPrivilegesWrapper } from '../ManageUsers/ManageUsersStyled';
import { Box } from '@mui/material';
const ViewDialog = ({ roleName,privileges,show,handleClose }) => {
  return (
    <div>
      <ViewPrivilegesWrapper
        open={show}
        onClose={handleClose}
        scroll="paper"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
          {Constants.PRIVILEGE}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className="customDialog">
            <Box>
              <Box className='roleBox'><h5>{roleName} {Constants.VIEWHEADING}</h5>
              <hr></hr>
              </Box>
              <div>
                <ul style={{textAlign:'left',marginLeft:'50px'}}>
                {privileges?.map((item) => (
                  <li style={{display: 'flex',alignItems:'center'}} >
                    <FiberManualRecordIcon fontSize='xs'/>
                 {item.actionName}
                  </li>
                ))}
              </ul>
              </div>
              </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions className='dialogbutton'>
           <Button variant="contained" color="success" onClick={handleClose}>{Constants.OK}</Button>
        </DialogActions>
      </ViewPrivilegesWrapper>
    </div>
  );
};

export default ViewDialog;
